<!--The content below is only a placeholder and can be replaced.-->
<div class="container">
    <div class="main-bar">
        <div class="top-bar">
            @if (context) {
                <app-menu-bar
                    [context]="context"
                    [validityReport]="validityReport"
                    [callbackHandler]="callbackHandler"
                    [addActionCallBack]="nodesManager.addAction.bind(nodesManager)"
                    [addTriggerCallBack]="nodesManager.addTrigger.bind(nodesManager)"
                    [addStepCallBack]="nodesManager.addStep.bind(nodesManager)"
                    [smsSubscriptionEnabled]="smsSubscriptionEnabled"
                    (elementVisibilityChanged)="onElementVisibilityChanged($event)"
                    (manageSettingsClick)="onManageSettingsClick()"
                    (recenterClick)="onRecenterClick()"
                    (rearrangeClick)="onRearrangeClick()"
                    (searchClick)="onSearchClick()"
                    (validityElementClick)="onValidityElementClick($event.elementType, $event.elementId)"></app-menu-bar>
            }
        </div>
        <div class="rete" #rete></div>
    </div>
    <div class="right-bar">
        @if (context) {
            <app-detail-bar
                [workflow]="context.workflow"
                [selection]="selectionHandler.selection"
                [activationEnabled]="!context.workflow?.isActive"
                (saved)="saveWorkflow()"
                (activated)="activateWorkflow()"
                (loaded)="loadWorkflow()"
                (stepSortingRequested)="sortSteps()"
                (formUpdated)="onFormUpdated($event)"></app-detail-bar>
        }
    </div>
</div>
<app-server-progress-bar-spinner></app-server-progress-bar-spinner>
